import {Observable, Subscription} from 'rxjs';

import EventType       from '../../Shared/Constants/EventType';
import dispatchEvent   from '../../Shared/Util/dispatchEvent';
import logger          from '../../Shared/Util/logger';
import IErrorsPayload  from '../Interfaces/IErrorsPayload';
import IPlayer         from '../Interfaces/IPlayer';

const subscribeToConsumerError = (
    consumerError$: Observable<IErrorsPayload>,
    player: IPlayer
): Subscription =>
    consumerError$
        .subscribe(consumerError => {
            dispatchEvent(player, EventType.ERROR, consumerError);

            logger.error(`[DAZN Web Player] ${consumerError.type}`, consumerError.source);
        });

export default subscribeToConsumerError;